import { sineOut } from 'svelte/easing';

const duration = 200;

export const fadeIn = () => ({
  duration,
  delay: duration,
  easing: sineOut,
  css: (t) => `opacity: ${t}`
});

export const fadeOut = () => ({
  duration,
  delay: 0,
  easing: sineOut,
  css: (t) => `opacity: ${t};position:absolute;width:100%;top:0;left:0;z-index:-1`
});
